import { useEffect } from "react";
import {
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";
import { COLORS } from "../../theme/colors";
import { Tooltip } from "./Tooltip";
import { TooltipContent } from "./TooltipContent";
import { nFormatter } from "../../services";

export const UnrealizedBarChart = ({
  chartData,
  height,
  barSize,
  top,
  bottom,
  hideYAxis,
  hideXAxis,
  colors,
}) => {
  useEffect(() => {
    setTimeout(() => {
      const tags = document.getElementsByClassName("estimated-bar");
      if (tags.length) {
        for (const tag of tags) {
          tag.setAttribute("stroke", COLORS.darks[0][100]);
          tag.setAttribute("stroke-dasharray", 3);
        }
      }
    }, 800);
  }, []);

  return (
    <ResponsiveContainer width="100%" height={height || 200}>
      <ReBarChart
        data={chartData}
        margin={{
          top: top || 5,
          bottom: bottom || 5,
        }}
        barSize={barSize || 15}
      >
        <ReferenceLine y={0} stroke="#000" />
        <CartesianGrid vertical={false} strokeDasharray="5 2" />
        {!hideXAxis && (
          <XAxis tickLine={false} dataKey="name" interval="preserveStartEnd" minTickGap={30} />
        )}
        {!hideYAxis && <YAxis axisLine={false} tickLine={false} tickFormatter={nFormatter} />}
        <Tooltip chartData={chartData} content={<TooltipContent />} />
        {Object.entries(colors).map((entry, index) => (
          <Bar key={index} dataKey={entry[0]} stackId="a" fill={entry[1]} />
        ))}
        <Bar className="estimated-bar" dataKey="estimated" stackId="a" fill={COLORS.darks[0][10]} />
      </ReBarChart>
    </ResponsiveContainer>
  );
};
